import {init_GLOBAL_events} from "./global";
import {init_USER_events} from "./user";
import {init_GTM_events} from "./gtm";
import {init_CARD_events} from "./card";
import {init_FILTER_events} from "./filter";
import sbjs from './lib/sbjs.js';
import './lib/typeahead.js';

// extend js
jQuery.fn.outerHTML = function() {
    return jQuery('<div />').append(this.eq(0).clone()).html();
};

jQuery.fn.scrollTo = function(elem) {
    $(this).scrollTop($(this).scrollTop() - $(this).offset().top + $(elem).offset().top);
    return this;
};

jQuery.fn.serializeAny = function() {
    let ret = [];
    $.each( $(this).find(':input'), function() {
        if (this.name!=='') {
            let input = $(this);
            if (((input.attr('type')=='checkbox' || input.attr('type')=='radio') && input.prop('checked')) || !(input.attr('type')=='checkbox' || input.attr('type')=='radio'))
                ret.push( encodeURIComponent(this.name) + "=" + encodeURIComponent( $(this).val() ) );
        }
    });

    return ret.join("&").replace(/%20/g, "+");
}

jQuery.fn.serializeObject = function() {
    let ret = {};
    $.each( $(this).find(':input'), function() {
        if (this.name!=='') {
            const input = $(this);
            if (((input.attr('type')=='checkbox' || input.attr('type')=='radio') && input.prop('checked')) || !(input.attr('type')=='checkbox' || input.attr('type')=='radio')) {
                ret[this.name] = $(this).val();
            }
        }

    });

    return ret;
}

// temporary set old coo    kies to new cookies, remove after 7 days
// ---- remove ----
import Cookies from 'js-cookie';

let tmp_cookies = [
    'cart_current',
    'cart_current_add',
    'cart_first',
    'cart_first_add',
    'cart_session',
    'cart_udata',
    'cart_promo'
];

tmp_cookies.map(i => {
    // console.log(i);
    let renamed = i.replace('cart_', 'sbjs_');
    if (Cookies.get(renamed) && !Cookies.get(i)) {
        Cookies.set(i, Cookies.get(renamed), {
            domain: `.${document.location.host}`
        })
    }
});
// ---- remove ----

sbjs.init({
    // domain: 'ktc.ua',
    timezone_offset: +3,
    lifetime: 2,
    campaign_param: '_ac',
    content_param: 'content'
});

init_GTM_events();
init_GLOBAL_events();
init_CARD_events();
init_USER_events();
init_FILTER_events();